<template>
  <div>
    <div class="section">
      <h2 class="Title is-size-2"> {{title}} </h2>
      <div class="line"/>
    </div>
    <div>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section',
  props: {
    title: String
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .section{
    display: flex;
    align-content: center;
    align-items: center;
    flex-direction: column;
  }

  .Title{
    text-align: center;
    width: 100%;
  }

  .line{
    width: 25%;
    height: 2px;
    max-height: 2px;
    min-height: 2px;
    background: var(--second-color);
  }


@media screen and (min-width:601px){
  .line{
    width: 25%;
  }
}

@media screen and (max-width:600px){
  .line{
    width: 70%;
  }
}



</style>
